var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurve2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 325,
    viewBox: "0 0 35 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.639 240.444C231.266 316.956 135.005 343.316 66.8578 300.514C-1.2897 257.712 -16.6728 161.23 33.701 84.7179C84.0748 8.20616 180.335 -18.1545 248.483 24.6479C316.63 67.4502 332.013 163.932 281.639 240.444Z",
    stroke: "#1F3549",
    strokeOpacity: 0.6,
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve2);
export default __webpack_public_path__ + "static/media/curve2.e997adefde8b2c1974bb3ff7bfde6b42.svg";
export { ForwardRef as ReactComponent };